import React, { useEffect, useRef, useState } from 'react'
import { Check } from 'react-feather'
import { Input } from 'reactstrap'
import styled from 'styled-components'

import { queries } from '~/constants/mediaQuery'
import useMultiPropState from '~/hooks/useMultiPropState'
import Select from '~/components/Select'
import CheckBox from './Checkbox'
import { Show } from './commons'

const campaignOptions = [
  { label: 'locasty_{{store_code}}', value: 'locasty_{{store_code}}' },
  { label: 'locasty_{{local_city}}', value: 'locasty_{{local_city}}' },
  { label: 'locasty_{{local_area}}', value: 'locasty_{{local_area}}' },
]

function WebsiteTrackedInput({
  onChange,
  value: _value,
  initialValue,
  ...props
}) {
  const [baseUrl, setBaseUrl] = useState('')
  const [tracks, setTracks] = useState(false)
  const [inputs, handleInputChange, setInputs] = useMultiPropState({
    source: '',
    medium: '',
    campaign: '',
  })
  const handleChange = useRef()
  handleChange.current = onChange

  useEffect(() => {
    if (!initialValue) return

    try {
      const url = new URL(initialValue)
      setBaseUrl(url.origin)
      const source = url.searchParams.get('utm_source')
      const medium = url.searchParams.get('utm_medium')
      const campaign = url.searchParams.get('utm_campaign')

      if (source || medium || campaign) {
        setTracks(true)
        handleInputChange('source', source)
        handleInputChange('medium', medium)
        handleInputChange('campaign', campaign)
      }
    } catch (error) {
      setBaseUrl(initialValue)
    }
  }, [initialValue])

  useEffect(() => {
    if (!baseUrl) {
      handleChange.current('')
      return
    }

    try {
      const url = new URL(baseUrl)

      Object.entries(inputs)
        .filter(([, value]) => !!value)
        .forEach(([key, value]) => {
          url.searchParams.append(`utm_${key}`, value)
        })

      handleChange.current(url.toString())
    } catch (error) {
      handleChange.current(baseUrl)
    }
  }, [baseUrl, inputs])

  return (
    <WebsiteContainer>
      <Input
        value={baseUrl}
        type="url"
        onChange={e => setBaseUrl(e.target.value)}
        {...props}
      />
      <div className="mb-1">
        <CheckBox
          color="primary"
          label="Tracking this click on results"
          size="sm"
          icon={<Check className="vx-icon" size={10} />}
          checked={tracks}
          onChange={e => {
            if (!e.target.checked) {
              setInputs({})
            }
            setTracks(e.target.checked)
          }}
        />

        <Show condition={!!tracks}>
          <UTMConfigContainer>
            <label>
              utm_source
              <Input
                value={inputs.source}
                onChange={e => handleInputChange('source', e.target.value)}
              />
            </label>
            <label>
              utm_medium
              <Input
                value={inputs.medium}
                onChange={e => handleInputChange('medium', e.target.value)}
              />
            </label>
            <label style={{ minWidth: 180 }}>
              utm_campaign
              <Select
                value={{ label: inputs.campaign, value: inputs.campaign }}
                options={campaignOptions}
                onChange={e => handleInputChange('campaign', e.value)}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
            </label>
          </UTMConfigContainer>
        </Show>
      </div>
    </WebsiteContainer>
  )
}

const WebsiteContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const UTMConfigContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 78%;

  label {
    font-size: 14px;

    input {
      font-size: 11px;
    }
  }

  @media ${queries.less.xll} {
    flex-direction: column;

    label {
      width: 100%;
    }
  }
`

export default WebsiteTrackedInput
